import { Navigate } from 'react-router-dom';
import UserData from '../utils/UserData';
import { useIsAuthenticated } from '@azure/msal-react';
import PrefixPath from 'config/AppConfig';
import PropTypes from 'prop-types'; // Import PropTypes
import { PAGE_CODES } from '../Constant/Roles';

function PublicRoute({ element }) {
  const { getUserLoginToken,getAccessPages } = UserData();
  let isToken = useIsAuthenticated();
  const isAuthenticated = getUserLoginToken();
  const userPermissions = getAccessPages();
  const isPageAccess = Object.values(PAGE_CODES).some(code => userPermissions.includes(code));
  
  const pageAccess = isPageAccess ? '/' : 'unauthorized'
  console.log(isToken && isAuthenticated,pageAccess,"requiredPageCode && !userPermissions?.includes(requiredPageCode)")
  return isToken && isAuthenticated ?  (
    <Navigate to={`${PrefixPath.APP_PREFIX_PATH}/${pageAccess}`} />
  ) : (
    element
  );
}

PublicRoute.propTypes = {
  element: PropTypes.node.isRequired, // 'element' should be a node (renderable JSX)
};

export default PublicRoute;
